import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';

import { Link } from 'react-router-dom';
import { Button } from '@salesforce/design-system-react';
import { Desert, GoneFishing, Compass } from './images/illustrations/no-data';

import './NoDataScreen.scss';

class NoData extends Component {
  illustration() {
    switch (this.props.screen) {
      case 'selections':
        return <GoneFishing />;
      case 'styleguides':
        return <Compass />;
      default:
        return <Desert />;
    }
  }

  render() {
    const { formatMessage } = this.props.intl;
    let button = this.props.button;
    if (this.props.screen === 'fallback') {
      button = (
        <Link to={{ pathname: '/classes' }}>
          <Button
            variant="brand"
            label={formatMessage({
              id: `components.ecs.noDataScreen.${this.props.screen}.button`
            })}
          />
        </Link>
      );
    }

    const helpLink = this.props.helpLink ? (
      <a rel="noopener noreferrer" target="_blank" href={this.props.helpLink}>
        {formatMessage({
          id: 'components.ecs.nocatalog.helpLinkText'
        })}
      </a>
    ) : null;

    return (
      <div className="dashboard-no-data-container">
        {this.illustration()}
        <div className="slds-text-longform">
          <h1 className="slds-text-heading_medium">
            <FormattedMessage
              id={`components.ecs.noDataScreen.${this.props.screen}.header`}
            />
          </h1>
          <p className="slds-text-heading_xsmall">
            <FormattedMessage
              id={`components.ecs.noDataScreen.${this.props.screen}.description`}
              values={{
                link: helpLink
              }}
            />
          </p>
          {button}
        </div>
      </div>
    );
  }
}

NoData.propTypes = {
  intl: intlShape.isRequired,
  screen: PropTypes.string.isRequired,
  button: PropTypes.element,
  helpLink: PropTypes.string
};

export default injectIntl(NoData);
